import { render, staticRenderFns } from "./_TodoActionsGantt.vue?vue&type=template&id=24c31d14&scoped=true&"
import script from "./_TodoActionsGantt.vue?vue&type=script&lang=js&"
export * from "./_TodoActionsGantt.vue?vue&type=script&lang=js&"
import style0 from "./_TodoActionsGantt.vue?vue&type=style&index=0&id=24c31d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c31d14",
  null
  
)

export default component.exports